import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchLatestKnowledgeFailure, fetchLatestKnowledgeSuccess } from "domains/monitor/latestKnowledge/actions";
import type { LatestKnowledgeDefaultAction } from "domains/monitor/latestKnowledge/actionTypes";
import type { KnowledgeResponse } from "entities/knowledge/types";

export const LATEST_KNOWLEDGE_LIMIT = 14;

export function* latestKnowledgeSaga({ meta }: LatestKnowledgeDefaultAction) {
  try {
    const { offset, limit = LATEST_KNOWLEDGE_LIMIT, filters } = meta;
    const payload: KnowledgeResponse[] = yield apiFetch("monitor/segmentation/latest_knowledge", {
      queryParams: {
        limit: limit,
        offset: offset * limit,
        ...filters,
      },
    });
    yield put(fetchLatestKnowledgeSuccess(meta, payload));
  } catch {
    yield put(fetchLatestKnowledgeFailure());
  }
}
